<template>
  <div class="agreeWrap">
    <div class="container-bd">
      <div class="c-left">
        <div class="blue">
          <p>
            <span>【重要】</span
            >在您注销您的源石帐号之前，请充分阅读、理解并同意下列事项:
          </p>
          <p>
            <span>【特别提示】</span
            >注销源石帐号为不可恢复的操作，除您已授权提供至第三方的信息以外，注销帐号后您将无法再使用本源石帐号或找回您浏览、收藏、参与活动的任何内容或信息(即使您使用相同的手机号码再次注册并使用源石)。请确保您所申请注销的源石帐号应当是您本人依照《源石用户协议》的约定创建并由本公司提供给您本人的帐号。您应当依照本公司规定的程序或网站_上的提示注销源石帐号。建议您在注销前自行备份源石帐号相关的所有信息，并请确认与本源石帐号相关的所有服务均已进行妥善处理。注销完成后，源石将删除您的个人信息或对其进行匿名化处理(法律法规另有规定的除外)。请您知悉并理解，根据相关法律法规规定相关日志记录源石将保留不少于6个月的时间。
          </p>
        </div>
        <div class="mod">
          <div class="bd">
            <h4>
              1.我们对您注销源石帐号的决定深表遗憾。如果您仍决定继续进行帐号注销，您的帐号需同时满足以下条件:
            </h4>
            <ol class="list decimal-list">
              <li>
                1.1帐号处于安全状态:帐号处于正常使用状态，无被盗风险
              </li>
              <li>
                1.2帐号财产已结清，没有未完成或存在争议的服务:帐号中没有资产、欠款、未结清的资金和虚拟权益;本帐号及通过本帐号接入的第三方中没有未完成或存在争议的服务。
              </li>

              <li>
                1.3帐号权限解除:帐号已解除与第三方产品、网站授权登录或绑定关系。
              </li>
              <li>
                1.4帐号无任何未结争议纠纷，包括投诉举报或被投诉举报。
              </li>
            </ol>
            <h4>
              2.源石帐号注销后，您将无法登录、使用本源石帐号，也将无法找回本源石帐号中及与帐号相关的任何内容或信息，包括但不限于:
            </h4>
            <ol class="list decimal-list">
              <li>
                2.1.个人已提交的身份信息、帐号信息等信息。
              </li>
              <li>
                2.2.已收藏的作品、点赞、评论、转发、互动、浏览历史等内容数据。
              </li>
              <li>
                2.3.通过本源石帐号使用、授权登录或绑定本源石帐号后使用的源石或第三方服务的相关记录将无法找回。您将无法再登录、使用上述服务，通过上述服务曾获得的资产或虚拟权益等财产性利益视为您同意放弃，将无法继续使用。您理解并同意，源石无法协助您重新恢复上述服务。
              </li>
              <li>
                2.4.帐号内钱包账户余额、钻石票，推荐票、奖励、收益、实名认证信息、交易记录、已绑定的银行卡等信息将被作废及删除。请确认帐号内无任何资产或虚拟权益，您曾获得的资产虚拟权益等财产性利益视为您同意放弃，将无法继续使用。您理解并同意，您将放弃源石的资产或权益，源石无法协助您恢复上述服务，也无法找回帐号相关的任何内容或信息。
              </li>
            </ol>
            <h4>
              3.源石帐号注销将导致本公司终止为您提供服务，依《源石用户协议》和《隐私政策》等约定的双方权利义务终止，依法律法规另有规定、本页面其他条款另行约定不得终止的或依其性质不能终止的除外。
            </h4>

            <h4>
              4.在您的源石帐号注销期间，如果您的帐号涉及争议纠纷，包括但不限于:投诉、举报、诉讼、仲裁、国家有权机关调查等，您理解并同意，源石有权自行决定是否终止本帐号的注销而无需另行得到您的同意。
            </h4>

            <h4>
              5.注销本源石帐号并不代表本源石帐号注销前的账户行为和相关责任得到豁免或减轻。
            </h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped>
.agreeWrap
   color #636778
   padding 49px 24px 30px
   font-size 26px
   letter-spacing 2px
   line-height 42px
   h6
        font-size 30px
        margin 15px 0
   h3
        font-size 32px
        margin 30px 0
   h4
        margin 30px 0
   .blue
        padding 28px 40px
        background:rgba(237,241,247,1);
        border-radius:14px;
        span
            font-weight 600
    .mod
        padding 36px 12px
        font-size 28px
        li
            text-indent 20px
</style>
